<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <canvas ref="my-canvas"></canvas>
    </div>
</template>

<script>
import CChart from "./cchart/CChart";
import DiffChart from "./cchart/Template/DiffChart";
import UrlResolver from "../services/UrlResolver";
import ValueChecker from "../services/ValueChecker";

import ComponentTitle from "@/components/ComponentTitle.vue";
import ActionComponent from "./grid/ActionComponent";

export default {
    components: {ComponentTitle, ActionComponent},
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            type: Object,
        },
        extraData: {
            Type: Object,
        },
        index: {
            Type: Number
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        },
    },
    computed: {
    },
    data() {
        return {
            cChart: null,
            firstLoading: false,
            loadMask: '',
            events: [],
            moduleIndex: null,
            resizeCallback: null,
            state: {},
            internalLoadEvent: null
        };
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted() {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);
            this.moduleIndex = moduleIndex;
            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.mountEvents();
            });
        });
    },
    methods: {
        mountEvents() {
            this.resizeCallback = () => {
                setTimeout(() => {
                    let c = this.$refs['my-canvas'];
                    c.width = c.parentElement.clientWidth;
                    c.height = c.parentElement.clientHeight;
                }, 1000);
            };

            window.addEventListener('resize', this.resizeCallback);
            this.eventBus.$on('Dashboard:toggleMenu', this.resizeCallback);
            this.events.push('Dashboard:toggleMenu');

            let eventManagerService = this.$root.getEventManager();
            eventManagerService.bindEvents(this.defaultBindEvents(), this);
            this.bindLoadEvent();

            this.eventBus.$on(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, (filterName, filterValue, filter, filters, serializedFilters) => {
                this.state = Object.assign(this.state, serializedFilters);
                this.loadMask = 'lmask';
                eventManagerService.emitEvents(this.internalLoadEvent, [{'state': this.state}]);
            });

            this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
        },

        unmountEvents() {
            window.removeEventListener('resize', this.resizeCallback);

            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        },
        getComponentIndex() {
            return `${this.config.index}`;
        },
        defaultBindEvents() {
            let componentIndex = this.getComponentIndex();

            let bindEvents = [{
                name: 'afterLoadEvent',
                componentIndex: componentIndex,
            }];

            if (this.config.bindEvents) {
                let configBindEvents = [];

                (this.config.bindEvents || []).forEach(e => {
                    configBindEvents.push(Object.assign({}, e));
                });
                bindEvents = bindEvents.concat(configBindEvents);
            }

            return bindEvents;
        },
        bindLoadEvent(callback) {
            if (null === this.internalLoadEvent) {
                this.internalLoadEvent = this.config.emitEvents['load'] || [];

                this.internalLoadEvent.push({
                    type: 'frontend',
                    config: {
                        eventName: `${this.config.index}:afterLoadEvent`,
                        callback: callback,
                        data: {
                            data: "1"
                        }
                    }
                });
            }
        },

        afterLoadEvent(config, data) {
            let d = data.data.data;
            let c = this.$refs['my-canvas'];
            let labelFieldName = '';
            let records = [];
            let chartConfig = {labels: []};
            let height = 0;
            let max = 0;
            let fields = [];
            let labels = [];

            if (!ValueChecker.isUndefinedOrNull(this.cChart)) {
                this.cChart.clear();
                delete this.cChart;
            }

            this.cChart = new CChart(c, new DiffChart(), this.eventBus);

            this.config.labels.forEach((value) => {
                if (value.type === 'label') {
                    labelFieldName = value.data;
                }

                if (value.type === 'data') {
                    let label = {};

                    label.name = value.name;

                    if (value.config.length !== 0) {
                        if (value.config['color'].length !== 0) {
                            label.color = value.config['color'];
                        }
                    }

                    labels.push(label);
                    fields.push(value.data);
                }
            });

            chartConfig = {
                callback: (data, group) => {
                    if (this.config.embeddedModules.length === 0) {
                        return;
                    }
                    let embeddedModule = this.config.embeddedModules[0];
                    data['group'] = group;
                    let url = UrlResolver.resolveUrl(embeddedModule.url, data, embeddedModule.query, this.state);
                    window.open(url);
                },
                labels: labels,
                max: max,
            };

            for (const [key, value] of Object.entries(d)) {
                let record = {items: [], label: '', group: []};

                if (labelFieldName in value) {
                    record['label'] = value[labelFieldName];
                }

                fields.forEach((field, index) => {
                    if (field in value) {
                        record['items'].push(value[field]);
                    }
                });

                record['group'] = fields;

                if ('extraData' in this.config) {
                    this.config.extraData.forEach((ed) => {
                        if ('name' in ed) {
                            if ('value' in ed) {
                                record[ed.name] = ed.value;
                            }
                            if ('data' in ed && ed.data in value) {
                                record[ed.name] = value[ed.data];
                            }
                        }
                    });
                }

                height += 30;

                records.push(record);
            }

            height += 60;
            c.height = height;

            this.cChart.setConfig(chartConfig);
            this.cChart.setData(records);
            this.cChart.render();

            this.loadMask = '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// ChartCanvasComponent.vue?31b31429